import {
  PostprocessingEffectName,
  PostprocessingEffectProps,
} from "@/types/vault-object-filter-types";
import * as Postprocessing from "@react-three/postprocessing";
import { GAIA_FOV } from "@/utils/cameraUtil";
import useVaultFilterStore from "@/stores/zustand/vault/useVaultFilterStore";

export function HengeDepthOfField({
  ...props
}: PostprocessingEffectProps[typeof PostprocessingEffectName.DepthOfField]) {
  const currentFilter = useVaultFilterStore((state) => state.currentFilter);

  const distanceRatio =
    Math.tan(((GAIA_FOV / 2) * Math.PI) / 180) /
    Math.tan(((currentFilter.camera.fov / 2) * Math.PI) / 180);

  return (
    <Postprocessing.DepthOfField
      {...props}
      worldFocusDistance={
        props.worldFocusDistance
          ? props.worldFocusDistance * distanceRatio
          : undefined
      }
      worldFocusRange={
        props.worldFocusRange
          ? props.worldFocusRange * distanceRatio
          : undefined
      }
      focusDistance={
        props.focusDistance ? props.focusDistance * distanceRatio : undefined
      }
      focalLength={
        props.focalLength
          ? props.focalLength * (GAIA_FOV / currentFilter.camera.fov)
          : undefined
      }
      bokehScale={
        props.bokehScale
          ? props.bokehScale *
            Math.log(Math.E + 1 / Math.log(Math.E + distanceRatio))
          : undefined
      }
    />
  );
}
